import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";

import { showAuthWindow } from "../../../actions/ui";

export const LoginButtonComponent = ({ oAuthError, showAuthWindowHandler }) => {
  return (
    <Button
      fullWidth
      variant="contained"
      color="primary"
      sx={theme => ({
        margin: theme.spacing(3, 0, 2),
        maxWidth: "100px",
      })}
      disabled={oAuthError !== null && oAuthError !== undefined}
      onClick={() => showAuthWindowHandler(true)}
    >
      Login
    </Button>
  );
};

LoginButtonComponent.defaultProps = {
  oAuthError: null,
};

LoginButtonComponent.propTypes = {
  oAuthError: PropTypes.string,
  showAuthWindowHandler: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  oAuthError: state.oauth.error,
  showOAuthWindow: state.ui.showOAuthWindow,
});

const mapDispatchToProps = {
  showAuthWindowHandler: show => dispatch => dispatch(showAuthWindow(show)),
};

const LoginButton = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginButtonComponent);

export default LoginButton;
